<script>
  export default {
    name: 'Contact',
  }
</script>

<template>
  <div class="section-container">
    <h2>CONTACT</h2>

    <div id="contact-infos">
      <p>Pascal Chôve</p>
      <p>kalchove3@gmail.com</p>
    </div>
  </div>
</template>

<style scoped>
  .section-container {
    min-height: 40vh;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  #contact-infos {
    height: 30vh;
    display: flex;
    flex-direction: column;
    justify-content: center;

    p {
      font-size: 1.5em;
    }
  }
</style>
